import NodeHtmlParser from "node-html-parser"

export default function domParser(html: string) {
  const parsedHtml = NodeHtmlParser.parse(html)
  return parsedHtml
}
